import { rejects } from "assert";

export const loadPageImages = $page => {
  if ($page.hasClass("lazyload-done")) return;
  const loadings = $page.find(".section__img.lazyload").map(async function() {
    if ($(this).hasClass("image-loaded")) return;
    await loadImage($(this).data("src"));
    $(this).attr("src", $(this).data("src"));
    $(this).addClass("image-loaded");
  });
  return Promise.all(loadings).then(() => {
    $page.addClass("lazyload-done");
  });
};

export const loadImage = src =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject;
    img.src = src;
  });
